import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var CloudLightning = createReactComponent("CloudLightning", ["svg", defaultAttributes, [["path", {
  d: "M19 16.9A5 5 0 0018 7h-1.26a8 8 0 10-11.62 9",
  key: "1yaqsn"
}], ["polyline", {
  points: "13 11 9 17 15 17 11 23",
  key: "pzjnu5"
}]]]);
export default CloudLightning;